import { isUserColumnStateEventSource } from '../persistence/useColumnStatePersistence'

const USER_FILTER_EVENT_SOURCES = new Set<string>([
  'columnFilter',
  'advancedFilter',
  'floatingFilter',
  'filterToolPanelUi',
  'columnMenu',
  'toolPanelUi',
])

export const isUserGridViewEvent = (event: unknown): boolean => {
  if (!event || typeof event !== 'object') return false
  const source = (event as { source?: unknown }).source
  return (
    isUserColumnStateEventSource(source) ||
    (typeof source === 'string' && USER_FILTER_EVENT_SOURCES.has(source))
  )
}
